
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conditions-generales",
      function () {
        return require("private-next-pages/conditions-generales.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conditions-generales"])
      });
    }
  